import { env } from '@/config/env';

/**
 * Extract the first letters from a string (up to 2 characters)
 * Useful for generating avatar initials
 */
export const extractFirstLetters = (text?: string): string => {
  if (!text) return '';
  const words = text.split(' ');
  const firstLetters = words.map((word) => word.charAt(0));
  return firstLetters.join('').slice(0, 2);
};

/**
 * Add the backend host prefix to a relative URL
 * If the URL is already absolute, return it as-is
 */
export const addHostPrefix = (url?: string): string => {
  if (!url) return '';
  // If URL is already absolute (starts with http:// or https://), return as-is
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }
  // The leading slash is stripped before joining: the backend now hands out
  // ROOT-relative paths (/api/v2/users/…/avatar/…), and a plain concat would
  // yield host//api/v2/… — Express 5 does not collapse the empty segment, so
  // every such URL would 404.
  return `${env.BACKEND_ENDPOINT}/${url.replace(/^\/+/, '')}`;
};

const OBJECT_ID_HEX = /^[0-9a-f]{24}$/i;

/**
 * Whether an id is a real persisted ObjectId rather than a client-minted
 * placeholder (`temp-draft-step-…`). Anything sent to an endpoint that casts
 * the value to an ObjectId has to pass this first.
 */
export function isObjectIdHex(id: string): boolean {
  return OBJECT_ID_HEX.test(id);
}
